'use strict';

const CollectionView = require('./collection');

const SectionView = require('./section');

class SectionsView extends CollectionView {
  tagName() {
    return 'ul';
  }

  initialize() {
    this.module = 'glive_booking_redesign';
    this.childView = SectionView;
  }

  attributes() {
    return { 'data-bhw': 'SectionPicker' };
  }
  constructor() {
    super(...arguments);
    this.on('select', this.select, this);
  }

  select(section) {
    this.options.selected = section;
    this.render();
  }
}

module.exports = SectionsView;
